import React from "react";
import Feature from "../../components/feature/Feature";
import "./features.css";

const Features = () => {
  return (
    <div className="gpt3__features-container" id="possibility">
      <div className="gpt3__features-internalContainer">
        <div className="gpt3__features-left">
          <h3 className="gpt3__features-titleBackground">
            The Future is Now and You Just Need To Realize It. Step into Future
            Today & Make it Happen.
          </h3>
          <div className="gpt3__features-row_linkContainer">
            <a href="#" className="gpt3__features-a">
              Request Early Access to Get Started
            </a>
          </div>
        </div>
        <div className="gpt3__features-right">
          <Feature
            title="Improving end distrusts instantly"
            text="From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded."
            type="feature-horizontal size14"
          />
          <Feature
            title="Become the tended active"
            text="Considered sympathize ten uncommonly occasional assistance sufficient not. Letter of on become he tended active enable to."
            type="feature-horizontal size14"
          />
          <Feature
            title="Message or am nothing"
            text="Led ask possible mistress relation elegance eat likewise debating. By message or am nothing amongst chiefly address."
            type="feature-horizontal size14"
          />
          <Feature
            title="Really boy law county"
            text="Really boy law county she unable her sister. Feet you off its like like six. Among sex are leave law built now. In built table in an rapid blush."
            type="feature-horizontal size14"
          />
        </div>
      </div>
    </div>
  );
};

export default Features;
